import { OTHER_DEPARTMENTS_GROUP_LABEL } from "@features/department/constants/departmentIds";
import {
  DepartmentSelectItem,
  partitionDepartmentsForSelect,
} from "@features/department/utils/partitionDepartmentsForSelect";

export type GroupedDepartmentFilterOption = {
  value: number;
  label: string;
  group?: string;
};

/**
 * SearchBar-compatible department options: Main Office ungrouped, others under Other departments.
 */
export function buildGroupedDepartmentFilterOptions(
  departments: DepartmentSelectItem[]
): GroupedDepartmentFilterOption[] {
  const { mainOffice, others } = partitionDepartmentsForSelect(departments);
  const options: GroupedDepartmentFilterOption[] = [];

  if (mainOffice) {
    options.push({
      value: mainOffice.department_id,
      label: mainOffice.name || `Department ${mainOffice.department_id}`,
    });
  }

  for (const dept of others) {
    options.push({
      value: dept.department_id,
      label: dept.name || `Department ${dept.department_id}`,
      group: OTHER_DEPARTMENTS_GROUP_LABEL,
    });
  }

  return options;
}
